(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-scratch-default-events.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-scratch-default-events.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef;
const useScratchDefaultEventsLeiaFactory = _ref => {
  var _confettiRef$current;
  let _ref$demo = _ref.demo,
    demo = _ref$demo === void 0 ? false : _ref$demo,
    ticketInfo = _ref.ticketInfo,
    isFullScreenGame = _ref.isFullScreenGame,
    _ref$gameIsCompleted = _ref.gameIsCompleted,
    gameIsCompleted = _ref$gameIsCompleted === void 0 ? false : _ref$gameIsCompleted,
    onPlayAgain = _ref.onPlayAgain,
    _ref$hasUnscratchedTi = _ref.hasUnscratchedTicket,
    hasUnscratchedTicket = _ref$hasUnscratchedTi === void 0 ? false : _ref$hasUnscratchedTi,
    _ref$hasNextVoucher = _ref.hasNextVoucher,
    hasNextVoucher = _ref$hasNextVoucher === void 0 ? false : _ref$hasNextVoucher,
    onClose = _ref.onClose,
    _ref$test = _ref.test,
    test = _ref$test === void 0 ? false : _ref$test;
  const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.customTexts,
    autoCorrect = _svs$ticketgames$tick.autoCorrect,
    confirmClose = _svs$ticketgames$tick.confirmClose;
  const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils.resultDialog,
    resultDialogNormal = _svs$ticketgames$tick2.resultDialogNormal,
    resultDialogDemo = _svs$ticketgames$tick2.resultDialogDemo;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    gameResult = _useState2[0],
    setGameResult = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldShowPlayAgainFooter = _useState4[0],
    setShouldShowPlayAgainFooter = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    shouldShowBubbleWinMessage = _useState6[0],
    setShouldShowBubbleWinMessage = _useState6[1];
  const _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  const _svs$ticketgames$tick3 = svs.ticketgames.ticketUtility.utils.useLeiaSoundStatus({
      ticketInfo
    }),
    soundStatus = _svs$ticketgames$tick3.soundStatus,
    notifySoundStatus = _svs$ticketgames$tick3.notifySoundStatus;
  const confettiRef = useRef(null);
  const lastOpenDoorRef = useRef(null);
  const handleGameLoaded = () => {
    setIsLoading(false);
  };
  const logCorrectionMethod = result => {
    var _result$data;
    const type = ticketInfo.type;
    if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && (_result$data = _result$data.revelationData) !== null && _result$data !== void 0 && _result$data.hasOwnProperty('autoCorrected')) {
      const autoCorrected = result.data.revelationData.autoCorrected;
      svs.ticketgames.ticketUtility.logger.info("CorrectionMethod (".concat(type, "): ").concat(autoCorrected ? 'AUTO' : 'MANUAL'));
    }
  };
  const showWinDialog = result => {
    if (demo) {
      resultDialogDemo({
        wonAmount: result.wonAmount,
        onClose,
        onPlayAgain
      });
    } else {
      const isTicketOpen = ticketInfo.open;
      resultDialogNormal({
        wonAmount: result.wonAmount,
        onClose,
        onPlayAgain,
        hasNextVoucher,
        hasUnscratchedTicket,
        isTicketOpen
      });
    }
  };
  const handleGameComplete = _ref2 => {
    let result = _ref2.detail;
    if (!demo && !gameIsCompleted) {
      var _svs$ticketgames$tick4;
      (_svs$ticketgames$tick4 = svs.ticketgames.ticketUtility.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick4 === void 0 || _svs$ticketgames$tick4.corrected(result);
      logCorrectionMethod(result);
    }
    const gameResult = svs.ticketgames.ticketUtility.utils.normalizeWin(result);
    setGameResult(gameResult);
    if (gameResult && (!isFullScreenGame || gameIsCompleted)) {
      setShouldShowPlayAgainFooter(true);
    }
    setTimeout(() => {
      setShouldShowBubbleWinMessage(true);
    }, test ? 0 : 500);
    if (gameResult.winFlag && !demo) {
      setTimeout(() => {
        switch (ticketInfo.type) {
          case 'svstriss30campaign49y24w37':
            svs.ticketUtility.utils.starConfetti();
            break;
          default:
            confettiRef.current = svs.tur.confettiCannon();
            break;
        }
      }, test ? 0 : 1000);
    }
    if (isFullScreenGame && !gameIsCompleted) {
      showWinDialog(result);
    }
    svs.components.account_balance && svs.components.account_balance.get(true);
  };
  const onAutoCorrect = () => {
    const type = ticketInfo.type;
    const _autoCorrect = autoCorrect(type),
      title = _autoCorrect.title,
      message = _autoCorrect.message,
      cancelTitle = _autoCorrect.cancelTitle,
      actionTitle = _autoCorrect.actionTitle;
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: 'help-2',
      title,
      message,
      actions: [{
        title: cancelTitle,
        callback: () => {
          var _gameloaderHelper$ins;
          (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins = _gameloaderHelper$ins.notifierProxy) === null || _gameloaderHelper$ins === void 0 || _gameloaderHelper$ins.sendNotification('autoCorrect', false);
          dialog.close();
        }
      }, {
        title: actionTitle,
        callback: () => {
          var _gameloaderHelper$ins2;
          (_gameloaderHelper$ins2 = gameloaderHelper.instance) === null || _gameloaderHelper$ins2 === void 0 || (_gameloaderHelper$ins2 = _gameloaderHelper$ins2.notifierProxy) === null || _gameloaderHelper$ins2 === void 0 || _gameloaderHelper$ins2.sendNotification('autoCorrect', true);
          dialog.close();
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  };
  const onOpenDoor = _ref3 => {
    let data = _ref3.detail;
    if (!demo) {
      var _data$ticket, _data$ticket2, _svs$ticketgames$tick5;
      const currentCall = {
        doorsOpened: (_data$ticket = data.ticket) === null || _data$ticket === void 0 || (_data$ticket = _data$ticket.revelationData) === null || _data$ticket === void 0 ? void 0 : _data$ticket.doorsOpened,
        ticketId: (_data$ticket2 = data.ticket) === null || _data$ticket2 === void 0 ? void 0 : _data$ticket2.id
      };
      const lastCall = lastOpenDoorRef.current;

      if (lastCall && lastCall.doorsOpened === currentCall.doorsOpened && lastCall.ticketId === currentCall.ticketId) {
        return; 
      }
      lastOpenDoorRef.current = currentCall;
      (_svs$ticketgames$tick5 = svs.ticketgames.ticketUtility.utils.tracking.gameSpecificTracking[ticketInfo.type]) === null || _svs$ticketgames$tick5 === void 0 || _svs$ticketgames$tick5.openDoor(data);
    }
  };
  const onCloseGame = event => {
    var _event$detail;
    const type = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.type;
    if (type === 'CONFIRM') {
      const _confirmClose = confirmClose(ticketInfo.type, demo),
        title = _confirmClose.title,
        message = _confirmClose.message,
        cancelTitle = _confirmClose.cancelTitle,
        actionTitle = _confirmClose.actionTitle;
      const dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.TUR,
        icon: 'help-2',
        title,
        message,
        actions: [{
          title: cancelTitle,
          callback: () => {
            dialog.close();
          }
        }, {
          title: actionTitle,
          callback: () => {
            onClose();
            dialog.close();
          }
        }]
      });
      svs.components.dialog.api.add(dialog);
    } else {
      onClose();
    }
  };
  const handleHasBet = _ref4 => {
    let detail = _ref4.detail;
    if (!demo) {
      const receiptId = detail.receiptId;
      history.replaceState(null, '', receiptId + window.location.search);
    }
  };
  useEffect(() => {
    const scratchDefaultEventsLeia = [{
      eventName: 'HAS_BET',
      handler: handleHasBet
    }, {
      eventName: 'GAME_LOADING',
      handler: handleGameLoaded
    }, {
      eventName: 'HAS_CLAIMED',
      handler: handleGameComplete
    }, {
      eventName: 'REPLAY_FINISHED',
      handler: handleGameComplete
    }, {
      eventName: 'SHOULD_AUTO_CORRECT',
      handler: onAutoCorrect
    }, {
      eventName: 'OPEN_DOOR',
      handler: onOpenDoor
    }, {
      eventName: 'CLOSE_GAME',
      handler: onCloseGame
    }];
    scratchDefaultEventsLeia.forEach(evt => addEventListener(evt.eventName, evt.handler));
    return () => {
      scratchDefaultEventsLeia.forEach(evt => removeEventListener(evt.eventName, evt.handler));
    };
  }, []);
  return {
    isLoading,
    gameResult,
    shouldShowPlayAgainFooter,
    shouldShowBubbleWinMessage,
    soundStatus,
    notifySoundStatus,
    destroyConfetti: confettiRef === null || confettiRef === void 0 || (_confettiRef$current = confettiRef.current) === null || _confettiRef$current === void 0 ? void 0 : _confettiRef$current.destroy
  };
};
setGlobal('svs.ticketgames.ticketUtility.utils.useScratchDefaultEventsLeiaFactory', useScratchDefaultEventsLeiaFactory);

 })(window);